import usePdpAtom from '../usePDPAtom';
const DEFAULT_VALUE = [];
const usePdpOptionsOrderAtom = () => {
  const pdpOptionsOrderAtom = usePdpAtom("pdpOptionsOrderAtom", DEFAULT_VALUE);
  return pdpOptionsOrderAtom;
};
export default usePdpOptionsOrderAtom;